/**
 * Interface to Brooklyn Content Filters API
 * @module services/content-filters
 */
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import { fromJS } from 'immutable'
import request from '../request'
import { createAuthorization } from '../auth'

/**
 * Get Content Filters by id from Brooklyn
 */
export async function getContentFiltersById ({ auth, server, id }) {
  if (!id) {
    throw new Error('Please provide a content filter id')
  }
  try {
    const res = await request
      .get(`${server}/v1/content-filters/${id}`)
      .set('authorization', createAuthorization(auth))
      .set('accept', 'application/json')
    return fromJS(_get(res, 'body', []))
  } catch (error) {
    if (error.status === 404) {
      const err = new Error(`No content filters found for ${id}`)
      err.status = 404
      throw err
    }
    throw error
  }
}

/**
 * Get a list of content filters from Brooklyn
 */
export async function getContentFiltersList (options = {}) {
  const { auth, server, filter = {} } = options
  let url = `${server}/v1/content-filters/list`
  if (!_isEmpty(filter)) {
    url += '?'
    if (filter.contentReferenceTypesId) {
      url += `contentReferenceTypesId=${filter.contentReferenceTypesId}&limit=200`
    }
  }
  const res = await request
    .get(url)
    .set('accept', 'application/json')
    .set('authorization', createAuthorization(auth))
  return fromJS(_get(res, 'body', {}))
}

/**
 * Create a Content Filter on Brooklyn
 */
export async function createContentFilter ({ auth, server, contentFilter }) {
  try {
    const res = await request
      .post(`${server}/v1/content-filters`)
      .send(contentFilter)
      .set('authorization', createAuthorization(auth))
      .set('accept', 'application/json')
    return fromJS(_get(res, 'body', {}))
  } catch (error) {
    if (error.status === 409) {
      const err = new Error(`Unable to create a Content Filter with options: ${contentFilter}`)
      err.status = 409
      throw err
    }
    throw error
  }
}

/**
 * Delete a Content Filter by id from Brooklyn
 */
export async function deleteContentFilterById ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/v1/content-filters/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}
